import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import api from '../config/axios';
import Footer from '../components/footer';
import Menu from '../components/menu';

const Unsubscribe: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState<string>('');
  const [requestSent, setRequestSent] = useState(false); // Pour suivre si la requête a été envoyée
  
  useEffect(() => {    
    
    if (!token || requestSent) {
        return; // Ne rien faire si le token est absent ou si une requête a déjà été envoyée
      }

    const unsubscribe = async () => {
        setRequestSent(true); // Marquer que la requête a été envoyée
      try {
        const response = await api.get(`/users/unsubscribe/${token}`);
        setStatus('success');
        setMessage(response.data.message || 'Vous avez été désinscrit de notre newsletter avec succès.');
      } catch (error) {
        setStatus('error');
        setMessage('Une erreur est survenue lors du traitement de votre demande. Le lien est peut-être expiré ou invalide.');
        console.error('Unsubscribe error:', error);
      }
    };

    unsubscribe();
  }, [token]);

  return (
    <>
      <Menu />
      <div className="min-h-screen bg-gray-100 py-12">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg overflow-hidden md:max-w-lg">
          <div className="md:flex">
            <div className="w-full p-6">
              
              <div className="text-center">
                <h1 className="text-2xl font-bold text-gray-800 mb-6">
                  Désinscription Newsletter
                </h1>
                
                {status === 'loading' && (
                  <div className="flex justify-center mb-4">
                    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-orange-500"></div>
                  </div>
                )}
                
                {status === 'success' && (
                  <>
                    <div className="mb-6 flex justify-center">
                      <svg className="w-16 h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                    </div>
                    <p className="text-gray-600 mb-6">{message}</p>
                  </>
                )}
                
                {status === 'error' && (
                  <>
                    <div className="mb-6 flex justify-center">
                      <svg className="w-16 h-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                    </div>
                    <p className="text-gray-600 mb-6">{message}</p>
                  </>
                )}
                
                <a 
                  href="/" 
                  className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded transition-colors duration-200"
                >
                  Retour à l'accueil
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Unsubscribe;